// import { User } from `@/context/AuthContext`
import { getISODay, addDays } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

// export function getTotalPointsByType(user: User, pointType: string) {
// 	try {
// 		return user.point_categories[pointType]
// 	} catch {
// 		return 0
// 	}
// }

export function getClosestDaysOfNextWeek(dayOfWeek: number, fromDate = new Date()) {
  // Mon: 1, Tue: 2, Wed: 3, Thur: 4, Fri: 5, Sat: 6, Sun: 7
  const dayOfWeekMap = [0, 1, 2, 3, 4, 5, 6];

  // Converte hora local para PST
  const zonedFrom = utcToZonedTime(fromDate.toISOString(), `America/Los_Angeles`);

  // Horário local da máquina do usuario
  const localFrom = zonedTimeToUtc(zonedFrom, `America/Los_Angeles`);

  // Horário do Brasil
  const brazilFrom = utcToZonedTime(fromDate.toISOString(), `America/Sao_Paulo`);

  /*console.log(`UTC`)
	console.log(fromDate.toUTCString())
	console.log(fromDate.toISOString())
	console.log(`\nPST`)
	console.log(zonedFrom.toUTCString())
	console.log(zonedFrom.toISOString())
	console.log(zonedFrom.toLocaleString())
	console.log(`\nBRAZIL`)
	console.log(brazilFrom.toUTCString())
	console.log(brazilFrom.toISOString())
	console.log(brazilFrom.toLocaleString())
	console.log(`\nLOCAL`)
	console.log(localFrom.toUTCString())
	console.log(localFrom.toISOString())
	console.log(localFrom.toLocaleString())*/

  const offsetDaysToFirstDate = 7 - (getISODay(localFrom) - dayOfWeekMap[dayOfWeek]);
  const offsetDaysToSecondDate = 14 - (getISODay(localFrom) - dayOfWeekMap[dayOfWeek]);

  const firstDayOfWeek = addDays(localFrom, offsetDaysToFirstDate);
  const secondDayOfWeek = addDays(localFrom, offsetDaysToSecondDate);

  // return [ format(firstDayOfWeek, `EEE, MM-dd-yyyy`), format(secondDayOfWeek, `EEE, MM-dd-yyyy`)]
  return [firstDayOfWeek, secondDayOfWeek];
}

export function getMonthName(number: any): string {
  if (typeof number !== 'number') {
    return number;
  }

  const months = [
    `Janeiro`,
    `Fevereiro`,
    `Março`,
    `Abril`,
    `Maio`,
    `Junho`,
    `Julho`,
    `Agosto`,
    `Setembro`,
    `Outubro`,
    `Novembro`,
    `Dezembro`,
  ];

  if (number < 1 || number > 12) {
    return `Número inválido`;
  }

  return months[number - 1];
}

export type levelType = 'iniciante' | 'joga' | 'valeu' | 'mandou' | 'uau' | 'nenhum';

export const levels: levelType[] = ['iniciante', 'joga', 'valeu', 'mandou', 'uau'];

export function getLevelDescription(level: levelType, group?: string): string {
  if (typeof group === 'string' && group === 'NAO AVALIAVEL') {
    return 'Você está nesse grupo por não atender um ou mais dos critérios descritos na IN 403-1 item 7.2.7.2.';
  }

  switch (level) {
    case 'iniciante':
      return `Para atingir o próximo <b>nível Jogando Junto</b> você precisa ter enviado pelo menos 5 reconhecimentos para participantes diferentes, ter utilizado pelo menos 2 tipos de pontuação (#Valeu, #MandouBem e #UAU), receber reconhecimentos de pelo menos 3 pessoas diferentes e atingir pelo menos 1.000 pontos. <br /> <br />Essa informação é dinâmica e poderá ser alterada até a divulgação do resultado do ciclo.`;
    case 'joga':
      return `Para atingir o próximo <b>nível Valeu</b> você precisa ter pelo menos 2.000 pontos e estar com a pontuação classificada entre as 30% melhores do seu grupo <br /> <br /> Essa informação é dinâmica e poderá ser alterada até a divulgação do resultado do ciclo.`;
    case 'valeu':
      return `Para atingir o próximo <b>nível Mandou Bem</b> você precisa atingir pelo menos 3.000 pontos e estar com a pontuação classificada entre as 20% melhores do seu grupo. <br /> Atenção: você retornará ao nível anterior, caso sua pontuação não permaneça entre as 30% melhores do seu grupo. <br /> <br /> Essa informação é dinâmica e poderá ser alterada até a divulgação do resultado do ciclo.`;
    case 'mandou':
      return `Para atingir o próximo e <strong>último nível UAU</strong> você precisa atingir pelo menos 4.000 pontos e estar com a pontuação classificada entre as 10% melhores do seu grupo.<br /> Atenção: você poderá retornar a um dos níveis anteriores, caso sua pontuação não permaneça entre as 20% melhores do seu grupo. <br /> <br /> Essa informação é dinâmica e poderá ser alterada até a divulgação do resultado do ciclo.`;
    case 'uau':
      return `Atenção: você poderá retornar a um dos níveis anteriores, caso sua pontuação não permaneça entre as 10% melhores do seu grupo. <br /> <br /> Essa informação é dinâmica e poderá ser alterada até a divulgação do resultado do ciclo.`;
    default:
      return `Para atingir o  <strong>nível iniciante</strong> você precisa enviar pelo menos 1 reconhecimento. <br /> <br /> Essa informação é dinâmica e poderá ser alterada até a divulgação do resultado do ciclo.`;
  }
}

export function getLevelTitle(level: levelType): string {
  switch (level) {
    case 'iniciante':
      return `Iniciante`;
    case 'joga':
      return `Jogando Junto`;
    case 'valeu':
      return `Valeu`;
    case 'mandou':
      return `Mandou Bem`;
    case 'uau':
      return `UAU`;
    default:
      return `---`;
  }
}

export function getLevelStyle(currentLevel: string, itemLevel: string) {
  const levels = ['joga', 'valeu', 'mandou', 'uau'];
  const currentIndex = levels.indexOf(currentLevel);
  const itemIndex = levels.indexOf(itemLevel);

  return itemIndex <= currentIndex ? 'text-[#7CFFEB]' : '';
}

export function getLevelBarStyle(currentLevel: string, itemLevel: string) {
  const levels = ['joga', 'valeu', 'mandou', 'uau'];
  const currentIndex = levels.indexOf(currentLevel);
  const itemIndex = levels.indexOf(itemLevel);

  return itemIndex <= currentIndex ? 'bg-[#7CFFEB]' : 'border-[#C7D3EB] border';
}

export const ineligibleIdsArray = [
  13085, 13088, 13087, 3003, 13089, 13092, 13022, 13090, 13080, 13025, 3002, 13082, 13084, 13094, 13083, 13070, 13020, 13021,
  13026, 4005, 13000, 13071, 3001,
];

export function getNamedDates() {
  return {
    ciclo_1S2023: 1675652400000, // 01/02/2023 - Início do programa
    ciclo_2S2023: 1690772400000, // 31/07/2023 - Início 2S2023
    ciclo_1S2024: 1706886000000, // 02/02/2024 - Início 1S2024
    ciclo_2S2024: 1730084400000, // 28/10/2024 - Início 2S2024
    ciclo_1S2025: 1741575600000, // 10/03/2025 - Início 1S2025
    ciclo_2S2025: 1756350000000, // 28/08/2025 - Início 2S2025
    ciclo_1S2026: 1770692400000, // 10/02/2026 - Início 1S2026
    ciclo_2S2026: 1785985200000, // 06/08/2026 - Início 2S2026
  };
}

export function GetVersion(date: number) {
  if (date <= getNamedDates().ciclo_1S2024) {
    return 'v2';
  }

  if (date <= getNamedDates().ciclo_2S2024) {
    return 'v3';
  }

  return '';
}
